<template>
  <v-app>
    <v-bottom-sheet persistent content-class="terms-dialog" v-model="terms.dialog">
      <div class="td-header">
        <div>
          <h2>TERMOS DE USO</h2>
          <div>E POLÍTICA DE PRIVACIDADE</div>
        </div>

        <div class="td-return-screen">
          <v-icon @click="closeTerms()" color="white">mdi-close</v-icon>
        </div>
      </div>
      <div>
        <iframe
          style="width: -webkit-fill-available; height: 500px; margin: 10px"
          :src="'https://termos.checkmotors.net/termos-de-uso-e-politica-de-privacidade.html?v=' + new Date().getTime()"
        ></iframe>
      </div>
    </v-bottom-sheet>

    <v-bottom-sheet persistent content-class="terms-dialog" v-model="membershipTerms.dialog">
      <div class="td-header">
        <h2>TERMOS DE ADESÃO</h2>

        <div class="td-return-screen">
          <v-icon @click="closeMembershipTerms()" color="white">mdi-close</v-icon>
        </div>
      </div>
      <div>
        <iframe
          style="width: -webkit-fill-available; height: 500px; margin: 10px"
          :src="'https://termos.checkmotors.net/termos-de-adesao.html?v=' + new Date().getTime()"
        ></iframe>
      </div>
    </v-bottom-sheet>

    <v-main v-if="!loading">
      <router-view />
      <WhatsappProfile :whatsapp_profile="whatsapp_profile" />
    </v-main>

    <v-dialog v-model="isBlockModalOpen" fullscreen persistent>
      <v-card>
        <v-card-title class="headline">Accesso Restrito</v-card-title>
        <v-card-text>
          <v-alert type="error" :value="true" border="left" elevation="2" colored-border>
            <strong>Atenção!</strong> Você não tem permissão para acessar o sistema devido as configurações de seu turno de trabalho.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="checkCanAccessSystem"><v-icon left>mdi-refresh</v-icon>Verificar Acesso</v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-btn @click="logOutModalBlock"><v-icon left>mdi-logout</v-icon>Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { getToken } from '@/services/tokenService';

import WhatsappProfile from '@/views/WhatsappProfile';
import router from '@/router';
import UserService from '@/services/api/user';
import { mapState } from 'vuex';
import dexieDB from '@/services/dexieService';

export default {
  name: 'App',
  components: {
    WhatsappProfile
  },
  data: () => ({
    loading: true, // TODO: Rever
    whatsapp_profile: null,
    isBlockModalOpen: false
  }),
  computed: {
    ...mapState('Auth', ['can_access_system', 'user']),
    terms() {
      return this.$store.getters['Auth/terms'];
    },
    membershipTerms() {
      return this.$store.getters['Auth/membershipTerms'];
    },
    user_logged() {
      return this.$store.getters['Auth/user'];
    },
    parameterMediaBackupHours() {
      return this.$store.getters['Auth/parameters']?.find((parameter) => parameter.name === 'media_backup_hours_stored')?.value;
    }
  },
  mounted() {
    const self = this;

    this.$store.dispatch('Auth/getParametersFromLocal');

    getToken().then((token) => {
      if (token) {
        if (window.location.pathname !== '/403') {
          self.$store.subscribe((mutation) => {
            if (mutation.type === 'Auth/SET_USER') {
              self.loading = false;
            }
          });
        } else {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    });
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      const message = event.data;
      if (message) {
        const messageCode = message[0];
        const messageData = message[1];
        if (messageCode === 'set_client') {
          this.whatsapp_profile = JSON.parse(messageData);
        }
      }
    },
    acceptTerms() {
      this.$store.dispatch('Auth/acceptTerms');
    },
    openTerms() {
      this.$store.dispatch('Auth/openTerms');
    },
    closeTerms() {
      this.$store.dispatch('Auth/closeTerms');
    },
    rejectTerms() {
      this.$store.dispatch('Auth/logout');
      this.$router.push('/login');
    },
    checkStoreAccess() {
      this.isBlockModalOpen = !this.can_access_system;
    },
    closeMembershipTerms() {
      this.$store.dispatch('Auth/closeMembershipTerms');
    },
    logOutModalBlock() {
      this.$store.dispatch('Auth/logout');
      this.$router.push('/login');
      this.$store.dispatch('Auth/updateUserAccess', true);
    },
    async checkCanAccessSystem() {
      try {
        const response = await UserService.checkUserCanAccessSystem();

        this.$store.dispatch('Auth/updateUserAccess', response.data);

        if (!response.data) {
          this.$toast.error('Acesso não permitido');
        }
      } catch (error) {
        this.$toast.error('Erro ao verificar acesso');
      }
    }
  },
  watch: {
    user_logged(newVal) {
      if (newVal) {
        this.isBlockModalOpen = !this.can_access_system;

        router.beforeEach((to, from, next) => {
          this.checkStoreAccess();
          next();
        });
      }
    },
    can_access_system(newVal) {
      this.isBlockModalOpen = !newVal;
    },
    parameterMediaBackupHours() {
      if (!this.parameterMediaBackupHours) return;

      dexieDB.jobRemoveOldPhotos(this.parameterMediaBackupHours);
    }
  }
};
</script>

<style lang="scss">
.theme--light.v-application {
  color: rgba(0, 0, 0, 0.6) !important;
}

.v-tab {
  text-transform: uppercase !important;
}

.terms-dialog {
  background-color: #fff;

  .td-header {
    padding: 20px;
    background-color: #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .td-return-screen {
      cursor: pointer;
      background-color: #c7c7c7;
      border-radius: 50%;
      padding: 10px;

      &:hover {
        background-color: #d7d7d7;
      }
    }
  }
}
</style>
